import axios from "axios";

export default {
	listRubrics(ctx) {
		return axios.get("/v3/rubrics", {
			params: ctx
		});
	},
	listMasterRubrics(ctx) {
		return axios.get("/v3/masterrubrics", {
			params: ctx
		});
	},
	listAllRubrics() {
		return this.listRubrics({
			perPage: 0,
			currentPage: 0
		});
	},
	listAllMasterRubrics() {
		return this.listMasterRubrics({
			perPage: 0,
			currentPage: 0
		});
	},
	saveRubric(rubric) {
		return axios.post("/v3/rubric", rubric);
	},
	saveTempRubric(rubric) {
		return axios.post("/v3/temp_rubric", rubric);
	},
	removeRubric(id) {
		return axios.delete(`/v3/rubric/${id}`);
	},
	removeTempRubric(id) {
		return axios.delete(`/v3/temp_rubric/${id}`);
	},
	fetchRubric(id) {
		return axios.get(`/v3/rubric/${id}`);
	},

	isScored(id) {
		return axios.get(`/v3/rubric_scored/${id}`);
	},

	getExemplars(rubricID, traitID, score, ctx) {
		return axios.get(
			`/v3/rubric/${rubricID}/trait/${traitID}/score/${score}/exemplars`,
			{
				params: ctx
			}
		);
	},

	getExemplarPool(rubricID, traitID, score, ctx) {
		return axios.get(
			`/v3/rubric/${rubricID}/trait/${traitID}/score/${score}/exemplar_pool`,
			{
				params: ctx
			}
		);
	},

	assignExemplar(rubricID, traitID, score, responseID) {
		return axios.post(
			`/v3/rubric/${rubricID}/trait/${traitID}/score/${score}/exemplar/assign/${responseID}`
		);
	},

	unassignExemplar(rubricID, traitID, score, exemplarID) {
		return axios.post(
			`/v3/rubric/${rubricID}/trait/${traitID}/score/${score}/exemplar/unassign/${exemplarID}`
		);
	},

	getExemplar(rubricID, traitID, score, exemplarID) {
		return axios.get(
			`/v3/rubric/${rubricID}/trait/${traitID}/score/${score}/exemplar/response/${exemplarID}`
		);
	},

	getPoolExemplar(exemplarID) {
		return axios.get(`/v3/pool_exemplar/${exemplarID}`);
	}
};



// WEBPACK FOOTER //
// ./src/services/RubricService.js